import SettingsModule from 'automation-ui-canvas/containers/settings/v2/SettingsModule';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import { NavMarker } from 'react-rhumb';
import SuppressionListControl from 'automation-ui-canvas/components/settings/v2/SuppressionListControl';
import GoalListControl from 'automation-ui-canvas/components/settings/v2/GoalListControl';
import ListeningControl from 'automation-ui-canvas/components/settings/v2/ListeningControl';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ClassicUnenrollmentSetting = ({
  flow,
  readOnly,
  settings: {
    classicEnrollmentSettings,
    isListeningSettingDisabled,
    goalFilters,
    suppressionLists,
    enrollmentList
  },
  onChange
}) => {
  return /*#__PURE__*/_jsx(SettingsModule, {
    header: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "settingsV2.unenrollmentTriggerSettingV2.title_cob",
      objectTypeId: flow.objectTypeId
    }),
    body: /*#__PURE__*/_jsxs(UIToggleGroup, {
      name: "unenrollment-options",
      children: [/*#__PURE__*/_jsx(SuppressionListControl, {
        suppressionLists: suppressionLists,
        flow: flow,
        readOnly: !!readOnly,
        classicEnrollmentSettings: classicEnrollmentSettings,
        onChange: onChange
      }), /*#__PURE__*/_jsx(NavMarker, {
        name: "WORKFLOW_GOALS",
        children: /*#__PURE__*/_jsx(GoalListControl, {
          classicEnrollmentSettings: classicEnrollmentSettings,
          goalFilters: goalFilters,
          readOnly: !!readOnly,
          flow: flow,
          onChange: onChange
        })
      }), /*#__PURE__*/_jsx(ListeningControl, {
        isListeningSettingDisabled: isListeningSettingDisabled,
        flow: flow,
        enrollmentList: enrollmentList,
        classicEnrollmentSettings: classicEnrollmentSettings,
        readOnly: !!readOnly,
        onChange: onChange
      })]
    })
  });
};
export default ClassicUnenrollmentSetting;